// 探活结果：区分失败原因，供上层按"仅硬错(network_error)才切、timeout/离线不切"决策，
// 与 SW public/sw.js 的 probePrimaryRequestTest 判据保持一致（AbortError=timeout）。
export type ProbeReason =
  | "ok"
  | "timeout"
  | "network_error"
  | "http_error"
  | "bad_body";

export interface ProbeResult {
  ok: boolean;
  reason: ProbeReason;
}

export async function probeRequestTest(
  origin: string = location.origin,
  timeout = 2500
): Promise<ProbeResult> {
  const ctrl = new AbortController();
  const tid = window.setTimeout(() => ctrl.abort(), timeout);

  try {
    const res = await fetch(`${origin}/api/ng/request_test`, {
      method: "GET",
      cache: "no-store",
      credentials: "omit",
      signal: ctrl.signal,
    });
    if (!res.ok) return { ok: false, reason: "http_error" };

    const text = (await res.text()).trim();
    return text === "test_okay"
      ? { ok: true, reason: "ok" }
      : { ok: false, reason: "bad_body" };
  } catch (e: unknown) {
    // AbortController 超时 reject 为 AbortError；其余（DNS/拒连/TLS）归为 network_error。
    const aborted = e instanceof Error && e.name === "AbortError";
    return { ok: false, reason: aborted ? "timeout" : "network_error" };
  } finally {
    window.clearTimeout(tid);
  }
}
